import React from 'react';
import './Sidebar.css';

function Sidebar({ headings, activeHeadingId, onClickHeading }) {
  return (
    <div className="sidebar">
      <h4>目次</h4>
      <ul>
        {headings
          .filter(h => h.level !== 4)  // h4は除外
          .map(h => {
          const isActive = (h.id === activeHeadingId);
          const level = h.level || 2; 
          const indent = (level - 2) * 20; // h2:0px, h3:20px, h4:40px のインデント
          return (
            <li key={h.id} style={{ marginLeft: `${indent}px` }}>
              <button
                className={`toc-btn ${isActive ? 'active-heading' : ''} ${level === 2 ? 'toc-h2' : ''}`} // levelが2なら 'toc-h2' クラスを追加
                onClick={() => onClickHeading(h.id)}
              >
                {h.text}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Sidebar;